import { AccessLevel, TableAction } from '@tripointe/tripointe-cms/types';
import { allExcept } from './array.utils';

const allAvailableEntityActions = [
  'create' as TableAction,
  TableAction.view,
  TableAction.edit,
  TableAction.delete,
  TableAction.archive,
  TableAction.deleteArchive,
  TableAction.mobileMenu,
  TableAction.unarchive,
  TableAction.welcomeEmail,
  TableAction.duplicate,
  TableAction.download,
  TableAction.changeOrder,
  TableAction.select,
  TableAction.deselect,
  TableAction.dropdownChanged,
  TableAction.changeVisibility,
  TableAction.replyToMessage,
  TableAction.sendMessage,
  TableAction.copyLink,
  TableAction.sync,
  'manageDefaultPhases',
  'rowInfo'
];

const topAccessLevelActions = [
  TableAction.delete,
  TableAction.deleteArchive,
  TableAction.archive,
  TableAction.unarchive,
  TableAction.copyLink,
  TableAction.sync,
  'manageDefaultPhases'
];

const readEntityActions = [
  TableAction.view,
  TableAction.mobileMenu,
  TableAction.download,
  'rowInfo'
];

const ACTIONS_PER_MODULE = {
  contactTypes: {
    [AccessLevel.platformAdministrator]: allAvailableEntityActions,
    [AccessLevel.builderAdministrator]: allAvailableEntityActions,
    [AccessLevel.divisionAdministrator]: [TableAction.view]
  },
  home: {
    [AccessLevel.platformAdministrator]: allAvailableEntityActions,
    [AccessLevel.builderAdministrator]: allAvailableEntityActions,
    [AccessLevel.divisionAdministrator]: allAvailableEntityActions,
    [AccessLevel.administrator]: allAvailableEntityActions,
    [AccessLevel.user]: [TableAction.edit]
  },
  homePhotos: {
    [AccessLevel.platformAdministrator]: allAvailableEntityActions,
    [AccessLevel.builderAdministrator]: allAvailableEntityActions,
    [AccessLevel.divisionAdministrator]: allAvailableEntityActions,
    [AccessLevel.administrator]: allAvailableEntityActions
  }
};

export const getAvailableEntityActionsForRole = (
  role: AccessLevel,
  entityName?: string
): string[] => {
  if (entityName && ACTIONS_PER_MODULE[entityName]) {
    return ACTIONS_PER_MODULE[entityName][role] || [];
  }

  switch (role) {
    case AccessLevel.platformAdministrator:
    case AccessLevel.builderAdministrator:
      return allAvailableEntityActions;
    case AccessLevel.divisionAdministrator:
    case AccessLevel.administrator:
    case AccessLevel.user:
      return allAvailableEntityActions.filter(allExcept(topAccessLevelActions));
    default:
      return readEntityActions;
  }
};
